import { IconGraph, IconPieChart, IconRewindPlay, IconDatabase, IconToggle, IconFlask, IconWarning, IconMessage, IconPlug, IconLogomark, IconBook, IconPiggyBank, IconLlmAnalytics } from '@posthog/icons';
import { CalloutBox } from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  IconGraph,
  IconPieChart,
  IconRewindPlay,
  IconDatabase,
  IconToggle,
  IconFlask,
  IconWarning,
  IconMessage,
  IconPlug,
  IconLogomark,
  IconBook,
  IconPiggyBank,
  IconLlmAnalytics,
  CalloutBox,
  React
};